<template>
  <div>
    <Toolbar class="p-mb-4">
      <template v-slot:start>
        <b v-if="staff"
          >{{ staff.primeUser.userName }}, <br />
          ({{ staff.outlet.name }} - {{ staffPosition }})</b
        >
      </template>
      <template v-slot:end>
        <!-- Was a line of controls sized by hand in px with vw margins between
             them, which staggered on any narrow screen and pushed the buttons
             off the edge of the card. Now a filter bar that stacks on a phone
             and becomes a row when there is room, the same shape My Staffs
             uses. -->
        <div class="dashboard-filters">
        <div
          class="spinner-border text-primary"
          v-if="loadingDashboardData"
        ></div>
        <div v-if="searchFilterbyCategory == 2">
          <Calendar
            id="dateEnd"
            dateFormat="dd/mm/yy"
            placeholder="Pick Date"
            selectionMode="range"
            v-model="dateModel"
            :maxDate="new Date()"
            :class="{
              'p-invalid': !date[0],
            }"
          />
        </div>
        <div class="dashboard-filters__group">
          <Dropdown
            id="searchFilterbyCategory"
            v-model="searchFilterbyCategory"
            :options="searchFilterbyCategoryOptions"
            optionLabel="Choose category"
            placeholder="Select a category"
          >
            <template #value="slotProps">
              <div
                class="country-item country-item-value"
                v-if="slotProps.value"
              >
                <div>
                  {{ searchFilterbyCategoryName(slotProps.value) }}
                </div>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>
                  {{ searchFilterbyCategoryName(slotProps.option) }}
                </div>
              </div>
            </template>
          </Dropdown>
          <div
            class="spinner-border text-primary"
            v-if="isSuperAdmin && loadingOutlets"
          ></div>
          <Dropdown
            id="searchFilterbyOutlet"
            v-model="searchFilterbyOutlet"
            :options="searchFilterbyOutletOptions"
            optionLabel="Choose outlet"
            placeholder="Select a outlet"
            v-if="isSuperAdmin && !loadingOutlets"
          >
            <template #value="slotProps">
              <div
                class="country-item country-item-value"
                v-if="slotProps.value"
              >
                <div>
                  {{ slotProps.value.name }}
                </div>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>
                  {{ slotProps.option.name }}
                </div>
              </div>
            </template>
          </Dropdown>
          <Dropdown
            id="searchFilterbyWarranty"
            v-model="searchFilterbyWarranty"
            :options="searchFilterbyWarrantyOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Warranty filter"
          />
          <Dropdown
            id="searchFilterbyIth"
            v-model="searchFilterbyIth"
            :options="searchFilterbyIthOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="ITH filter"
          />
          <Dropdown
            id="searchFilterbyIpp"
            v-model="searchFilterbyIpp"
            :options="searchFilterbyIppOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="IPP filter"
          />
        </div>
        <Button
          :disabled="
            count - 1 !== searchFilterbyOutletOptions.length - 1 &&
            count - 1 > 0
          "
          id="search"
          :label="searchLabel"
          @click="getData()"
        />
        <Button id="print" label="Print" @click="printReport()" />
        </div>
      </template>
    </Toolbar>
    <div class="p-grid p-fluid dashboard">
      <!-- <div class="p-col-12 p-lg-4">
		<div class="card summary">
			<span class="title">Employee</span>
			<span class="detail">Number of <span>Employees</span></span>
			<span class="count visitors">25</span>
		</div>
	</div>
	<div class="p-col-12 p-lg-4">
		<div class="card summary">
			<span class="title">Customer</span>
			<span class="detail">Number of Customers (Today)</span>
			<span class="count purchases">2</span>
		</div>
	</div>
	<div class="p-col-12 p-lg-4">
		<div class="card summary">
			<span class="title">Sales</span>
			<span class="detail">Total Repairing Sales (Today)</span>
			<span class="count revenue">RM1,000</span>
		</div>
	</div> -->

      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #007be5; color: #00448f"
          >
            <span>A</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>Total Device Handled </span>
            <span class="count">{{ displayNumber.totalDeviceAll }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #c08de3; color: #9240c2"
          >
            <span>B</span>
          </div>
          <div class="highlight-details">
            <span>Total Device No Action Yet</span>
            <span class="count">{{
              displayNumber.totalDeviceNoActionYet
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #f9c851; color: #b58c2b"
          >
            <span>C</span>
          </div>
          <div class="highlight-details">
            <span>Total Device In Progress</span>
            <span class="count">{{ displayNumber.totalDeviceInProgress }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #20d077; color: #038d4a"
          >
            <span>D</span>
          </div>
          <div class="highlight-details">
            <span>Total Device Completed</span>
            <span class="count">{{ displayNumber.totalDeviceCompleted }}</span>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #007be5; color: #00448f"
          >
            <span>E</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>Waiting for Specialist </span>
            <span class="count">{{
              displayNumber.totalDeviceWaitSpecialist
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #c08de3; color: #9240c2"
          >
            <span>F</span>
          </div>
          <div class="highlight-details">
            <span>Waiting for Spare-part</span>
            <span class="count">{{
              displayNumber.totalDeviceWaitSparePart
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #f9c851; color: #b58c2b"
          >
            <span>G</span>
          </div>
          <div class="highlight-details">
            <span>Waiting for Customer</span>
            <span class="count">{{
              displayNumber.totalDeviceWaitCustomer
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-3">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #20d077; color: #038d4a"
          >
            <span>H</span>
          </div>
          <div class="highlight-details">
            <span>Completion Rate</span>
            <span class="count">{{
              Math.round(
                (displayNumber.totalDeviceCompleted /
                  displayNumber.totalDeviceAll) *
                  100,
              ) / 100
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6" style="height: 100%">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>I</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>T.D. In Progress </span> <br />
            <small>(Excl. Wait For Cust.)</small>
            <span class="count">{{
              displayNumber.totalDeviceInProgressExcludeWFC
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>J</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>No Action<br /><small>(>=48 Hours)</small> </span>
            <span class="count" style="display: fixed">{{
              displayNumber.totalDevice2DaysNoActionYet
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>W</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress<br /><small>(0-13 Days)</small> </span>
            <span class="count">{{
              displayNumber.totalDevice0to13DaysInProgress
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>X</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress </span> <br />
            <small>(0-13 Days) (Excl. W.F.C.)</small>
            <span class="count">{{
              displayNumber.totalDevice0to13DaysInProgressExcludeWFC
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>K</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress<br /><small>(14-20 Days)</small> </span>
            <span class="count">{{
              displayNumber.totalDevice2WeeksInProgress
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>L</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress </span> <br />
            <small>(14-20 Days) (Excl. W.F.C.)</small>
            <span class="count">{{
              displayNumber.totalDevice2WeeksInProgressExcludeWFC
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>M</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress<br /><small>(21-27 Days)</small> </span>
            <span class="count">{{
              displayNumber.totalDevice3WeeksInProgress
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>N</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress </span> <br />
            <small>(21-27 Days) (Excl. W.F.C.)</small>
            <span class="count">{{
              displayNumber.totalDevice3WeeksInProgressExcludeWFC
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>O</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress<br /><small>(28-34 Days)</small> </span>
            <span class="count">{{
              displayNumber.totalDevice4WeeksInProgress
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>P</span>
          </div>
          <div class="highlight-details">
            <!-- <i class="pi pi-search"></i> -->
            <span>In Progress </span> <br />
            <small>(28-34 Days) (Excl. W.F.C.)</small>
            <span class="count">{{
              displayNumber.totalDevice4WeeksInProgressExcludeWFC
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>S</span>
          </div>
          <div class="highlight-details">
            <span>In Progress<br /><small>(>=35 Days)</small> </span>
            <span class="count">{{
              displayNumber.totalDevice35DaysInProgress
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>T</span>
          </div>
          <div class="highlight-details">
            <span>In Progress </span> <br />
            <small>(>=35 Days) (Excl. W.F.C.)</small>
            <span class="count">{{
              displayNumber.totalDevice35DaysInProgressExcludeWFC
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #f9c851; color: #b58c2b"
          >
            <span>Q</span>
          </div>
          <div class="highlight-details">
            <span>Pending Ship to HQ Yet (&le;48 Hours)</span>
            <span class="count">{{
              displayNumber.totalTS_Cat2AwaitingSpecialist_New
            }}</span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-xl-6">
        <div class="highlight-box">
          <div
            class="initials"
            style="background-color: #ef6262; color: #a83d3b"
          >
            <span>R</span>
          </div>
          <div class="highlight-details">
            <span>Pending Ship to HQ (&gt;48 Hours)</span>
            <span class="count">{{
              displayNumber.totalTS_Cat2AwaitingSpecialist_Backlog
            }}</span>
          </div>
        </div>
      </div>
      <!-- Wrapped the way My Staffs wraps its table - p-col-12 then card - because
           this one was a bare child of .p-grid. A flex item will not shrink below
           its content, so a twenty column table with no column class around it
           grew the whole row and scrolled the page sideways, taking the content
           under the fixed sidebar with it. -->
      <div class="p-col-12">
        <div class="card">
          <DataTable
            v-if="displayNumbers.length > 0"
            :value="displayNumbers"
            dataKey="id"
            stripedRows
            responsiveLayout="stack"
            breakpoint="960px"
          >
            <Column field="id" header="ID"></Column>
            <Column field="name" header="Outlet"></Column>
            <Column field="totalDeviceAll" header="(A) Tot. Dev."></Column>
            <Column
              field="totalDeviceNoActionYet"
              header="(B) Tot. Dev. N.A.Y"
            ></Column>
            <Column
              field="totalDeviceInProgress"
              header="(C) Tot. Dev. I.P"
            ></Column>
            <Column
              field="totalDeviceCompleted"
              header="(D) Tot. Dev. Completed"
            ></Column>
            <Column
              field="totalDeviceWaitSpecialist"
              header="(E) Tot. Dev. W.F.S"
            ></Column>
            <Column
              field="totalDeviceWaitSparePart"
              header="(F) Tot. Dev. W.F.S.P"
            ></Column>
            <Column
              field="totalDeviceWaitCustomer"
              header="(G) Tot. Dev. W.F.C"
            ></Column>
            <Column field="completionRate" header="(H) Completion Rate"></Column>
            <Column
              field="totalDeviceInProgressExcludeWFC"
              header="(I) Tot. Dev. I.P X W.F.C"
            ></Column>
            <Column
              field="totalDevice2DaysNoActionYet"
              header="(J) Tot. Dev. 2D N.A.Y"
            ></Column>
            <Column
              field="totalDevice0to13DaysInProgress"
              header="(W) Tot. Dev. 0-13D I.P"
            ></Column>
            <Column
              field="totalDevice0to13DaysInProgressExcludeWFC"
              header="(X) Tot. Dev. 0-13D I.P X W.F.C"
            ></Column>
            <Column
              field="totalDevice2WeeksInProgress"
              header="(K) Tot. Dev. 2W I.P"
            ></Column>
            <Column
              field="totalDevice2WeeksInProgressExcludeWFC"
              header="(L) Tot. Dev. 2W I.P X W.F.C"
            ></Column>
            <Column
              field="totalDevice3WeeksInProgress"
              header="(M) Tot. Dev. 3W I.P"
            ></Column>
            <Column
              field="totalDevice3WeeksInProgressExcludeWFC"
              header="(N) Tot. Dev. 3W I.P X W.F.C"
            ></Column>
            <Column
              field="totalDevice4WeeksInProgress"
              header="(O) Tot. Dev. 4W I.P"
            ></Column>
            <Column
              field="totalDevice4WeeksInProgressExcludeWFC"
              header="(P) Tot. Dev. 4W I.P X W.F.C"
            ></Column>
            <Column
              field="totalDevice35DaysInProgress"
              header="(S) Tot. Dev. 35D+ I.P"
            ></Column>
            <Column
              field="totalDevice35DaysInProgressExcludeWFC"
              header="(T) Tot. Dev. 35D+ I.P X W.F.C"
            ></Column>
          </DataTable>
        </div>
      </div>
      <!-- <table v-if="showNumberTable">
          <thead>
            <th>ID</th>
            <th>Outlet</th>
            <th>Completion Rate</th>
            <th>Tot. Dev. 2D N.A.Y.</th>
            <th>Tot. Dev 2W InProgress</th>
            <th>totalDevice2WeeksInProgressExcludeWFC</th>
            <th>totalDevice3WeeksInProgress</th>
            <th>totalDevice3WeeksInProgressExcludeWFC</th>
            <th>totalDevice4WeeksInProgress</th>
            <th>totalDevice4WeeksInProgressExcludeWFC</th>
            <th>totalDeviceAll</th>
            <th>totalDeviceCompleted</th>
            <th>totalDeviceInProgress</th>
            <th>totalDeviceInProgressExcludeWFC</th>
            <th>totalDeviceNoActionYet</th>
            <th>totalDeviceWaitCustomer</th>
            <th>totalDeviceWaitSparePart</th>
            <th>totalDeviceWaitSpecialist</th>
          </thead>
          <tbody>
            <tr  v-for="number in displayNumbers" :key="number.id">
            <td>{{number.id}}</td>
            <td>{{number.name}}</td>
            <td>{{Math.round((number.totalDeviceCompleted/number.totalDeviceAll) * 100) / 100}}</td>
            <td>{{number.totalDevice2DaysNoActionYet}}</td>
            <td>{{number.totalDevice2WeeksInProgress}}</td>
            <td>{{number.totalDevice2WeeksInProgressExcludeWFC}}</td>
            <td>{{number.totalDevice3WeeksInProgress}}</td>
            <td>{{number.totalDevice3WeeksInProgressExcludeWFC}}</td>
            <td>{{number.totalDevice4WeeksInProgress}}</td>
            <td>{{number.totalDevice4WeeksInProgressExcludeWFC}}</td>
            <td>{{number.totalDeviceAll}}</td>
            <td>{{number.totalDeviceCompleted}}</td>
            <td>{{number.totalDeviceInProgress}}</td>
            <td>{{number.totalDeviceInProgressExcludeWFC}}</td>
            <td>{{number.totalDeviceNoActionYet}}</td>
            <td>{{number.totalDeviceWaitCustomer}}</td>
            <td>{{number.totalDeviceWaitSparePart}}</td>
            <td>{{number.totalDeviceWaitSpecialist}}</td>
          </tr>
          </tbody>
        </table> -->
    </div>
  </div>
</template>

<script>
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import Toolbar from 'primevue/toolbar';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { session } from '../utils/session';
export default {
  components: { Calendar, Dropdown, Toolbar, DataTable, Column },
  data() {
    return {
      dateModel: null,
      date: { 0: null, 1: null },
      loadingDashboardData: false,
      activated: false,
      searchFilterbyCategory: 1,
      searchFilterbyCategoryOptions: [1, 2],
      searchFilterbyOutlet: { id: 0, name: 'All Outlets' },
      searchFilterbyWarranty: 'all',
      searchFilterbyWarrantyOptions: [
        { label: 'All', value: 'all' },
        { label: 'Warranty', value: true },
        { label: 'Non Warranty', value: false },
      ],
      searchFilterbyIth: 'nottrue',
      searchFilterbyIthOptions: [
        { label: 'All', value: 'all' },
        { label: 'All Except Active ITH', value: 'nottrue' },
        { label: 'Active ITH', value: true },
        { label: 'Done ITH', value: false },
        { label: 'Never ITH', value: 'null' },
      ],
      searchFilterbyIpp: 'all',
      searchFilterbyIppOptions: [
        { label: 'All', value: 'all' },
        { label: 'With IPP', value: true },
        { label: 'Without IPP', value: false },
      ],
      loadingOutlets: true,
      count: 0,
      showNumberTable: true,
      displayNumbers: [],

      displayNumber: {
        completionRate: 0,
        totalDevice2DaysNoActionYet: 0,
        totalDevice0to13DaysInProgress: 0,
        totalDevice0to13DaysInProgressExcludeWFC: 0,
        totalDevice2WeeksInProgress: 0,
        totalDevice2WeeksInProgressExcludeWFC: 0,
        totalDevice3WeeksInProgress: 0,
        totalDevice3WeeksInProgressExcludeWFC: 0,
        totalDevice4WeeksInProgress: 0,
        totalDevice4WeeksInProgressExcludeWFC: 0,
        totalDevice35DaysInProgress: 0,
        totalDevice35DaysInProgressExcludeWFC: 0,
        totalDeviceAll: 0,
        totalDeviceCompleted: 0,
        totalDeviceInProgress: 0,
        totalDeviceInProgressExcludeWFC: 0,
        totalDeviceNoActionYet: 0,
        totalDeviceWaitCustomer: 0,
        totalDeviceWaitSparePart: 0,
        totalDeviceWaitSpecialist: 0,
        totalTS_Cat2AwaitingSpecialist_New: 0,
        totalTS_Cat2AwaitingSpecialist_Backlog: 0,
      },
    };
  },

  mounted() {
    this.loadForSignedInStaff();
  },
  watch: {
    // Everything this page fetches is scoped to the signed-in staff, so there is
    // nothing to ask for until their profile has arrived. It can be absent on mount:
    // the lookup may still be in flight, or it may have failed. Signing in as someone
    // else replaces it, and this reloads the page's data for the new user rather than
    // leaving the previous one's on screen.
    staff: {
      immediate: false,
      handler: function (val) {
        if (val) {
          this.loadForSignedInStaff();
        }
      },
    },
    searchFilterbyCategory: function (val) {
      if (val) {
        // console.log(this.date);
        if (val == 1) {
          this.dateModel = null;
          this.activated = false;
          this.date = { 0: null, 1: null };
        } else if (val == 2) {
          this.dateModel = new Date();
          this.activated = false;
          this.date = { 0: new Date(), 1: null };
        }
        // this.getData();
      }
    },
    dateModel: function (val) {
      if (val) {
        if (this.activated) {
          this.date = val;
        }
        console.log(val);
        this.activated = true;
        // this.getData();
      }
    },
    searchFilterbyOutlet: function (val) {
      if (val) {
        // this.getData();
      }
    },
  },
  computed: {
    dashboardStatisticsBasic() {
      const basic = this.$store.getters['statistics/getDashboardStatisticsBasic'];
      return basic && basic.data ? basic.data.result : null;
    },
    staff() {
      // Guarded: this getter is empty until the lookup resolves, and stays empty
      // if it failed. Reaching through it threw and blanked the whole page.
      const staff = this.$store.getters['logged/getStaff'];
      return staff && staff.data ? staff.data.result : null;
    },
    staffPosition() {
      return session.staffPosition;
    },
    outlets() {
      let outlets = this.$store.getters['staff/outletsOnly'];
      return outlets;
    },
    searchLabel() {
      return (
        'Search (' +
        (this.count - 1) +
        '/' +
        (this.searchFilterbyOutletOptions.length - 1) +
        ')'
      );
    },
    isSuperAdmin() {
      if (!this.staff || !this.staff.staffPosition) {
        return false;
      }
      return (
        this.staff.staffPosition.name == 'HQ Administrator' ||
        this.staff.staffPosition.name == 'Kerawang Administrator'
      );
    },
    searchFilterbyOutletOptions() {
      if (Array.isArray(this.outlets)) {
        return [{ id: 0, name: 'All Outlets' }, ...this.outlets];
      } else {
        return [{ id: 0, name: 'All Outlets' }];
      }
    },
  },
  methods: {
    loadForSignedInStaff() {
      if (!this.staff) {
        return;
      }
      if (this.isSuperAdmin) {
        this.$store
          .dispatch('staff/getOutletsOnly', {
            organizationId: this.staff.outlet.organizationId,
          })
          .then(() => {
            this.loadingOutlets = false;
            this.getData();
          });
      } else {
        this.getData();
      }
    },
    async getData() {
      this.loadingDashboardData = true;
      const payloadWarranty =
        this.searchFilterbyWarranty === 'all'
          ? undefined
          : this.searchFilterbyWarranty;
      const payloadIth =
        this.searchFilterbyIth === 'all' ? undefined : this.searchFilterbyIth;
      const payloadIpp =
        this.searchFilterbyIpp === 'all' ? undefined : this.searchFilterbyIpp;
      this.displayNumber.completionRate = 0;
      this.displayNumber.totalDevice2DaysNoActionYet = 0;
      this.displayNumber.totalDevice0to13DaysInProgress = 0;
      this.displayNumber.totalDevice0to13DaysInProgressExcludeWFC = 0;
      this.displayNumber.totalDevice2WeeksInProgress = 0;
      this.displayNumber.totalDevice2WeeksInProgressExcludeWFC = 0;
      this.displayNumber.totalDevice3WeeksInProgress = 0;
      this.displayNumber.totalDevice3WeeksInProgressExcludeWFC = 0;
      this.displayNumber.totalDevice4WeeksInProgress = 0;
      this.displayNumber.totalDevice4WeeksInProgressExcludeWFC = 0;
      this.displayNumber.totalDevice35DaysInProgress = 0;
      this.displayNumber.totalDevice35DaysInProgressExcludeWFC = 0;
      this.displayNumber.totalDeviceAll = 0;
      this.displayNumber.totalDeviceCompleted = 0;
      this.displayNumber.totalDeviceInProgress = 0;
      this.displayNumber.totalDeviceInProgressExcludeWFC = 0;
      this.displayNumber.totalDeviceNoActionYet = 0;
      this.displayNumber.totalDeviceWaitCustomer = 0;
      this.displayNumber.totalDeviceWaitSparePart = 0;
      this.displayNumber.totalDeviceWaitSpecialist = 0;

      this.displayNumber.totalTS_Cat2AwaitingSpecialist_New = 0;
      this.displayNumber.totalTS_Cat2AwaitingSpecialist_Backlog = 0;

      this.displayNumbers = [];

      if (this.searchFilterbyOutlet.id === 0 && this.isSuperAdmin) {
        let current = 1;
        let reset = 1;

        do {
          let array = [];
          for (
            let i = current;
            i < current + 10 && i < this.searchFilterbyOutletOptions.length;
            i++
          ) {
            array.push(this.searchFilterbyOutletOptions[i]);
          }
          current += array.length;

          await Promise.all(
            array.map(
              async (value) =>
                await this.$store.dispatch(
                  'statistics/getDashboardStatisticsBasic',
                  {
                    staffId: this.staff.id,
                    staffPositionId: this.staff.staffPositionId,
                    date: this.date,
                    outletId: value.id,
                    isWarranty: payloadWarranty,
                    isIth: payloadIth,
                    isIpp: payloadIpp,
                  },
                ),
            ),
          ).then(async (response) => {
            response.forEach((data, index) => {
              this.displayNumber.completionRate +=
                data.data.result.completionRate;
              this.displayNumber.totalDevice2DaysNoActionYet +=
                data.data.result.totalDevice2DaysNoActionYet;
              this.displayNumber.totalDevice0to13DaysInProgress +=
                data.data.result.totalDevice0to13DaysInProgress;
              this.displayNumber.totalDevice0to13DaysInProgressExcludeWFC +=
                data.data.result.totalDevice0to13DaysInProgressExcludeWFC;
              this.displayNumber.totalDevice2WeeksInProgress +=
                data.data.result.totalDevice2WeeksInProgress;
              this.displayNumber.totalDevice2WeeksInProgressExcludeWFC +=
                data.data.result.totalDevice2WeeksInProgressExcludeWFC;
              this.displayNumber.totalDevice3WeeksInProgress +=
                data.data.result.totalDevice3WeeksInProgress;
              this.displayNumber.totalDevice3WeeksInProgressExcludeWFC +=
                data.data.result.totalDevice3WeeksInProgressExcludeWFC;

              this.displayNumber.totalDevice4WeeksInProgress +=
                data.data.result.totalDevice4WeeksInProgress;
              this.displayNumber.totalDevice4WeeksInProgressExcludeWFC +=
                data.data.result.totalDevice4WeeksInProgressExcludeWFC;
              this.displayNumber.totalDevice35DaysInProgress +=
                data.data.result.totalDevice35DaysInProgress;
              this.displayNumber.totalDevice35DaysInProgressExcludeWFC +=
                data.data.result.totalDevice35DaysInProgressExcludeWFC;
              this.displayNumber.totalDeviceAll +=
                data.data.result.totalDeviceAll;
              this.displayNumber.totalDeviceCompleted +=
                data.data.result.totalDeviceCompleted;
              this.displayNumber.totalDeviceInProgress +=
                data.data.result.totalDeviceInProgress;
              this.displayNumber.totalDeviceInProgressExcludeWFC +=
                data.data.result.totalDeviceInProgressExcludeWFC;
              this.displayNumber.totalDeviceNoActionYet +=
                data.data.result.totalDeviceNoActionYet;
              this.displayNumber.totalDeviceWaitCustomer +=
                data.data.result.totalDeviceWaitCustomer;
              this.displayNumber.totalDeviceWaitSparePart +=
                data.data.result.totalDeviceWaitSparePart;
              this.displayNumber.totalDeviceWaitSpecialist +=
                data.data.result.totalDeviceWaitSpecialist;

              this.displayNumber.totalTS_Cat2AwaitingSpecialist_New +=
                data.data.result.totalTS_Cat2AwaitingSpecialist_New;
              this.displayNumber.totalTS_Cat2AwaitingSpecialist_Backlog +=
                data.data.result.totalTS_Cat2AwaitingSpecialist_Backlog;

              this.loadingDashboardData = false;

              this.displayNumbers.push({
                id: array[index].id,
                name: array[index].name,
                completionRate:
                  Math.round(
                    (data.data.result.totalDeviceCompleted /
                      data.data.result.totalDeviceAll) *
                      100,
                  ) / 100,
                totalDevice2DaysNoActionYet:
                  data.data.result.totalDevice2DaysNoActionYet,
                totalDevice0to13DaysInProgress:
                  data.data.result.totalDevice0to13DaysInProgress,
                totalDevice0to13DaysInProgressExcludeWFC:
                  data.data.result.totalDevice0to13DaysInProgressExcludeWFC,
                totalDevice2WeeksInProgress:
                  data.data.result.totalDevice2WeeksInProgress,
                totalDevice2WeeksInProgressExcludeWFC:
                  data.data.result.totalDevice2WeeksInProgressExcludeWFC,
                totalDevice3WeeksInProgress:
                  data.data.result.totalDevice3WeeksInProgress,
                totalDevice3WeeksInProgressExcludeWFC:
                  data.data.result.totalDevice3WeeksInProgressExcludeWFC,
                totalDevice4WeeksInProgress:
                  data.data.result.totalDevice4WeeksInProgress,
                totalDevice4WeeksInProgressExcludeWFC:
                  data.data.result.totalDevice4WeeksInProgressExcludeWFC,
                totalDevice35DaysInProgress:
                  data.data.result.totalDevice35DaysInProgress,
                totalDevice35DaysInProgressExcludeWFC:
                  data.data.result.totalDevice35DaysInProgressExcludeWFC,
                totalDeviceAll: data.data.result.totalDeviceAll,
                totalDeviceCompleted: data.data.result.totalDeviceCompleted,
                totalDeviceInProgress: data.data.result.totalDeviceInProgress,
                totalDeviceInProgressExcludeWFC:
                  data.data.result.totalDeviceInProgressExcludeWFC,
                totalDeviceNoActionYet: data.data.result.totalDeviceNoActionYet,
                totalDeviceWaitCustomer:
                  data.data.result.totalDeviceWaitCustomer,
                totalDeviceWaitSparePart:
                  data.data.result.totalDeviceWaitSparePart,
                totalDeviceWaitSpecialist:
                  data.data.result.totalDeviceWaitSpecialist,
                totalTS_Cat2AwaitingSpecialist_New:
                  data.data.result.totalTS_Cat2AwaitingSpecialist_New,
                totalTS_Cat2AwaitingSpecialist_Backlog:
                  data.data.result.totalTS_Cat2AwaitingSpecialist_Backlog,
              });

              this.count = current;
            });
          });
        } while (this.count < this.searchFilterbyOutletOptions.length);
      } else {
        await this.$store
          .dispatch('statistics/getDashboardStatisticsBasic', {
            staffId: this.staff.id,
            staffPositionId: this.staff.staffPositionId,
            date: this.date,
            outletId: this.searchFilterbyOutlet.id,
            isWarranty: payloadWarranty,
            isIth: payloadIth,
            isIpp: payloadIpp,
          })
          .then((data) => {
            this.displayNumber.completionRate = data.data.result.completionRate;
            this.displayNumber.totalDevice2DaysNoActionYet =
              data.data.result.totalDevice2DaysNoActionYet;
            this.displayNumber.totalDevice0to13DaysInProgress =
              data.data.result.totalDevice0to13DaysInProgress;
            this.displayNumber.totalDevice0to13DaysInProgressExcludeWFC =
              data.data.result.totalDevice0to13DaysInProgressExcludeWFC;
            this.displayNumber.totalDevice2WeeksInProgress =
              data.data.result.totalDevice2WeeksInProgress;
            this.displayNumber.totalDevice2WeeksInProgressExcludeWFC =
              data.data.result.totalDevice2WeeksInProgressExcludeWFC;
            this.displayNumber.totalDevice3WeeksInProgress =
              data.data.result.totalDevice3WeeksInProgress;
            this.displayNumber.totalDevice3WeeksInProgressExcludeWFC =
              data.data.result.totalDevice3WeeksInProgressExcludeWFC;
            this.displayNumber.totalDevice4WeeksInProgress =
              data.data.result.totalDevice4WeeksInProgress;
            this.displayNumber.totalDevice4WeeksInProgressExcludeWFC =
              data.data.result.totalDevice4WeeksInProgressExcludeWFC;
            this.displayNumber.totalDevice35DaysInProgress =
              data.data.result.totalDevice35DaysInProgress;
            this.displayNumber.totalDevice35DaysInProgressExcludeWFC =
              data.data.result.totalDevice35DaysInProgressExcludeWFC;
            this.displayNumber.totalDeviceAll = data.data.result.totalDeviceAll;
            this.displayNumber.totalDeviceCompleted =
              data.data.result.totalDeviceCompleted;
            this.displayNumber.totalDeviceInProgress =
              data.data.result.totalDeviceInProgress;
            this.displayNumber.totalDeviceInProgressExcludeWFC =
              data.data.result.totalDeviceInProgressExcludeWFC;
            this.displayNumber.totalDeviceNoActionYet =
              data.data.result.totalDeviceNoActionYet;
            this.displayNumber.totalDeviceWaitCustomer =
              data.data.result.totalDeviceWaitCustomer;
            this.displayNumber.totalDeviceWaitSparePart =
              data.data.result.totalDeviceWaitSparePart;
            this.displayNumber.totalDeviceWaitSpecialist =
              data.data.result.totalDeviceWaitSpecialist;

            this.displayNumber.totalTS_Cat2AwaitingSpecialist_New =
              data.data.result.totalTS_Cat2AwaitingSpecialist_New;
            this.displayNumber.totalTS_Cat2AwaitingSpecialist_Backlog =
              data.data.result.totalTS_Cat2AwaitingSpecialist_Backlog;
            this.loadingDashboardData = false;
          });
      }
    },
    setDate() {
      this.date = null;
    },

    searchFilterbyCategoryName(value) {
      let filterString = '';
      switch (value) {
        case 1:
          filterString = 'All Date';
          break;
        case 2:
          filterString = 'By Date';
          break;
        default:
          filterString = '-';
      }
      return filterString;
    },
    async printReport() {
      try {
        window.print();
      } catch (err) {
        alert(
          'Sorry, this browser does not support this feature. Error: ' +
            err.message,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Mobile first: every control is its own full width row, which is the only
// arrangement seven of them can take at 360px. The row is what gets added once
// there is room, and the widths come from the layout rather than from a pixel
// figure typed into each control.
.dashboard-filters {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-2);
  width: 100%;

  &__group {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-2);
    min-width: 0;
  }

  ::v-deep(.p-dropdown),
  ::v-deep(.p-calendar),
  ::v-deep(.p-button),
  ::v-deep(.p-inputtext) {
    width: 100%;
  }
}

@media screen and (min-width: 640px) {
  .dashboard-filters {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    width: auto;

    &__group {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
    }

    // Minimums rather than fixed widths, so a long option label is not clipped
    // on a wide screen and the controls still wrap tidily on a narrow one.
    ::v-deep(.p-dropdown),
    ::v-deep(.p-calendar) {
      width: auto;
      min-width: 10rem;
    }

    ::v-deep(.p-button) {
      width: auto;
    }
  }
}
</style>
